import {PlayArrowRounded} from "@mui/icons-material";
import StateTimeIndicator from "./stateTimeIndicator";
import Thumbnail from "./thumbnail";

function GalleryItem({item, settings, onClick}) {
  const handleClick = () => {
    if(item.state==='vod' || item.state==='live'){
      onClick(item);
    }
  };
  return (
    <div className={`vf-gallery-item flex flex-col h-fit relative overflow-hidden group ${item.state==='vod' || item.state==='live' ? 'cursor-pointer' : ''} `} style={{paddingTop : settings.aspect}} onClick={handleClick}>
      <div className="absolute w-full h-full top-0 left-0">
        <Thumbnail item={item} settings={settings} className={`${item.state==='vod' || item.state==='live'? 'group-hover:scale-110 transition-transform ease-out duration-700 group-hover:blur-sm':'' }`}/>
      </div>
      
      {(settings.showName || settings.showDesc) && 
        <div className="vf-gallery-info text-[18px] absolute bottom-0 px-2 pb-5 w-full h-full z-20 bg-gradient-to-t from-black/80 to-transparent justify-end flex flex-col select-none">
          {settings.showName && <span className="vf-gallery-title text-white font-bold text-[1em]">{item.name}</span>}
          {settings.showDesc && <span className="vf-gallery-desc text-white leading-4 text-[0.8em]">{item.description}</span>}
        </div>
      }
      {(item.state==='vod' || item.state==='live') && <div className="bg-black/50 hidden text-white w-full h-full absolute top-0 left-0 md:flex justify-center items-center z-30 opacity-0 group-hover:opacity-100">
          <PlayArrowRounded sx={{ fontSize: 60 }}/>
      </div>}

      <StateTimeIndicator className="absolute top-2 left-0 z-40 rounded-r-md" item={item} settings={settings}/>
    </div>
  );
}

export default GalleryItem;
